import { toast } from 'react-toastify';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import * as actions from './Actions';
import * as api from './Api';
import Types from './Types';

function* getAllAssistants({ payload }) {
    try {
        yield put(actions.addAssistantsLoading(true));
        const result = yield call(api.getAllAssistants);
        const data = Array.isArray(result.data) ? result.data : (result.data?.data || result.data || []);
        yield put(actions.getAllAssistantsSuccess({ data }));
    } catch (error) {
        const { response, message } = error;
        toast.error(error?.response?.data?.message || 'Failed to fetch assistants');
        yield put(actions.getAllAssistantsFail());
    } finally {
        yield put(actions.addAssistantsLoading(false));
    }
}

function* editAssistant(data) {
    try {
        yield put(actions.addAssistantsLoading(true));
        const result = yield call(api.editAssistant, data.payload);
        // Handle response structure: result.data.data or result.data
        const assistantData = result.data?.data || result.data;
        if (assistantData) {
            yield put(actions.editAssistantSuccess({ data: assistantData }));
            toast.success(result.data?.message || result.data?.state || 'Edit Successfully');
            // Always call action to close modal
            if (data?.action) {
                data.action(assistantData);
            }
        } else {
            throw new Error('Invalid response structure');
        }
    } catch (error) {
        yield put(actions.editAssistantFail());
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to update assistant';
        toast.error(errorMessage);
    } finally {
        yield put(actions.addAssistantsLoading(false));
    }
}

function* createAssistant(formData) {
    try {
        yield put(actions.addAssistantsLoading(true));
        const result = yield call(api.createAssistant, formData.payload);
        const createdData = result.data?.data || result.data;
        yield put(
            actions.createAssistantSuccess({
                data: createdData
            })
        );
        toast.success('Created Successfully');
        formData?.action && formData?.action(createdData)
    } catch (error) {
        yield put(actions.createAssistantFail());
        toast.error(error?.response?.data?.message || 'Failed to create assistant');
    } finally {
        yield put(actions.addAssistantsLoading(false));
    }
}

function* deleteAssistant({ payload }) {
    try {
        yield put(actions.addAssistantsLoading(true));
        const result = yield call(api.deleteAssistant, payload);

        yield put(actions.deleteAssistantSuccess(payload));

        toast.success('Deleted Successfully');
    } catch (error) {
        const { response, message } = error;
        toast.error(error?.response?.data?.message || 'Failed to delete assistant');
        yield put(actions.deleteAssistantFail());
    } finally {
        yield put(actions.addAssistantsLoading(false));
    }
}

function* suspendAssistant({ payload }) {
    try {
        yield put(actions.addAssistantsLoading(true));
        const result = yield call(api.suspendAssistant, payload.id, payload.reason);

        yield put(actions.suspendAssistantSuccess({ payload: payload.id, result }));
        toast.success('Suspended Successfully');
    } catch (error) {
        const { response, message } = error;
        toast.error(error?.response?.data?.message || error?.message || 'Failed to suspend assistant');
        yield put(actions.suspendAssistantFail());
    } finally {
        yield put(actions.addAssistantsLoading(false));
    }
}

export default function* AssistantSaga() {
    yield takeLatest(Types.GET_ALL_ASSISTANTS_REQUEST, getAllAssistants);
    yield takeLatest(Types.EDIT_ASSISTANT_REQUEST, editAssistant);
    yield takeLatest(Types.CREATE_ASSISTANT_REQUEST, createAssistant);
    yield takeLatest(Types.DELETE_ASSISTANT_REQUEST, deleteAssistant);
    yield takeLatest(Types.SUSPEND_ASSISTANT_REQUEST, suspendAssistant);
}

